import React from 'react';
import { useTranslation } from 'react-i18next';
import parse from 'html-react-parser';
import { EmailChangeConfirmationBase } from '../EmailChangeConfirmationBase';
import Information from '../../Information/Information';
import styles from './EmailChangeConfirmation.module.scss';
import { LoginButton } from '../LoginButton/LoginButton';

export const EmailChangeConfirmation: React.FC = () => {
  const { t } = useTranslation();

  return (
    <EmailChangeConfirmationBase
      texts={{
        confirmHeader: t('email_change.confirm.header'),
        confirmBody: t('email_change.confirm.body'),
      }}
      invalidContent={(
        <Information
          headerText={t('email_change.already_confirmed.header')}
          bodyText={(
            <span className={styles.alreadyConfirmedBody}>
              {parse(t('email_change.already_confirmed.body'))}
            </span>
          )}
          endAdornment={<LoginButton />}
        />
      )}
    />
  );
}
